module.exports = "https://cdn.dove.it/_next/static/public/assets/press/logo-avvenire.7459e51a72f3e373c84a5ebc282557d9.png";